<template lang="pug">
  .verify-billing
    v-layout.my-6
      y-dialog(v-model='isLoading' persistent width='300')
        v-card(v-if="!hasResult" color='primary' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('processing_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('processing_text') }}

        v-card(v-if="isSuccess" color='success' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('success_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('success_text') }}

        v-card(v-if="isError" color='error' dark)
          v-card-text.pt-3
            p.mt-2 {{ $t('error_title') }}
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption {{ $t('error_text') }}

</template>

<script>
export default {
  name: 'VerifyPayment',
  props: ['lead'],
  data: () => ({
    isVerifying: true,
    isLoading: true,
    hasResult: false,
    isSuccess: false,
    isError: false,
    verifyingInterval: null,
    tryCount: 0,
    reDirectUrl: '/admin/dashboard'
  }),
  mounted () {
    this.tryCount = 1
    this.verifyingInterval = setInterval(() => {
      if (this.$route.query.method === 'billplz') {
        const result = this.$route.query['billplz[paid]']
        if (this.tryCount >= 5 && this.isVerifying) {
          this.isVerifying = false
          clearInterval(this.verifyingInterval)
          this.showResult(result == 'true')
        }
        this.tryCount++
      } else if (this.$route.query.success === 'true') {
        this.isVerifying = false
        clearInterval(this.verifyingInterval)
        this.showResult(true)
      } else {
        this.isVerifying = false
        clearInterval(this.verifyingInterval)
        this.showResult(false)
      }
    }, 1500)
  },
  methods: {
    showResult (result) {
      this.hasResult = true
      if (result) {
        this.isSuccess = true
      } else {
        this.isError = true
      }
      setTimeout(() => {
        if (this.isSuccess) {
          location.href = this.reDirectUrl + '?status=prepaid_topup_payment_success&bill_id=' + this.$route.query['billplz[id]']
        } else {
          location.href = this.reDirectUrl + '?status=prepaid_topup_payment_failed&bill_id=' + this.$route.query['billplz[id]']
        }
      }, 2000)
    }
  }
}
</script>

<style scoped>
.header {
  background: #F8F9FC;
  padding: 16px;
}
.content {
  padding: 16px;
}
</style>

<i18n>
{
  "en": {
    "processing_title": "Verifying payment...",
    "processing_text": "Please wait and do not close or refresh this page",
    "success_title": "Thank you!",
    "success_text": "Your payment is successful",
    "error_title": "Ops..",
    "error_text": "Your payment did not go through. Please try again later."
  },
  "id": {
    "processing_title": "Verifikasi pembayaran...",
    "processing_text": "Sila tunggu dan jangan tutup halaman ini",
    "success_title": "Terima kasih!",
    "success_text": "Pembayaran berjaya",
    "error_title": "Ops..",
    "error_text": "Pembayaran gagal. Sila cuba lagi nanti."
  }
}
</i18n>
